import { Component } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { Settings, AppSettings } from './components/shared/services/color-option.service';
import { Router, NavigationEnd } from '@angular/router';
import { AccountService } from './components/shared/services/account.service';
import { Title } from '@angular/platform-browser';
import { PublicService } from './components/shared/services/public.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  title = 'ecommerce-ls';
  public settings: Settings;
  public url : any;

  constructor(private spinner: NgxSpinnerService, 
              public appSettings:AppSettings, 
              public router: Router, 
              public account:AccountService,
              public publicData:PublicService,
              private titleService: Title) {
    this.settings = this.appSettings.settings;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.url = event.url;
      }
    } )
  }


  ngOnInit() {
    /** spinner starts on init */
    this.spinner.show();

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 5000);

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0,0)
  });
  this.publicData.getMainData().subscribe((res) => {
    document.documentElement.style.setProperty('--theme-deafult', res["color"]); 
    this.titleService.setTitle(res["WebTitulo"]);

  });

  }

}
